import React from 'react';
import { Box, TextField, Text } from '@customerio/pluma-components/react';

interface ObjectIdFilterProps {
  value: string;
  onChange: (value: string) => void;
  objectType?: string;
}

export function ObjectIdFilter({ value, onChange, objectType }: ObjectIdFilterProps) {
  const hasObjectType = objectType != null && objectType !== '';

  return (
    <Box p="300">
      {!hasObjectType ? (
        <Text size="s" color="subtle">
          Select an Object Type first to filter by Object ID.
        </Text>
      ) : (
        // Note: Using onInput instead of onChange is required for TextField to work correctly
        // in DataTable filter popovers. onChange causes the input to become unresponsive.
        <TextField
          label="Object ID"
          value={value ?? ''}
          onInput={(e) => onChange(e.target.value.trim())}
          placeholder="Enter object ID"
          id="audit-log-filter-object-id"
        />
      )}
    </Box>
  );
}
